import * as go from 'gojs/release/go-module';

import { ExtendedLink } from 'src/containers/ProjectDiagram/templates/extensions/link';
import { ExtendedNode } from 'src/containers/ProjectDiagram/templates/extensions/node';

export class ExtendedForceDirectedLayout extends go.ForceDirectedLayout {
  commitNodes() {
    if (!this.network) {
      return;
    }

    const allVertexes = this.network.vertexes.copy();

    this.network.vertexes.removeAll(
      allVertexes.filter(
        (vertex) => (vertex?.node as ExtendedNode)?.skipsLayoutCommit
      )
    );

    super.commitNodes();
    this.network.vertexes.addAll(allVertexes);
  }

  commitLinks() {
    if (!this.network) {
      return;
    }

    const allEdges = this.network.edges.copy();

    this.network.edges.removeAll(
      allEdges.filter((edge) => (edge?.link as ExtendedLink)?.skipsLayoutCommit)
    );

    super.commitLinks();
    this.network.edges.addAll(allEdges);
  }
}
